import { APIDataMedia } from '@evertel/types'
import { NormalizedMedia } from './NormalizedMediaType'
import { getMediaType } from '@evertel/utils'

export const APIDataMediaToNormalizedMedia = ((m: APIDataMedia, heicSupport = false): NormalizedMedia => {
    let mediaType = getMediaType(m.mimetype, heicSupport)
    const versions = (m.meta as any)?.versions

    // HEIC/HEIF on platforms without native support (web/Android) is classified as
    // 'application' so it renders as a file download. But if the API has already
    // processed JPEG versions, we can safely treat it as 'image' since the display
    // path will request a JPEG version (?ver=optimized), not the raw HEIC.
    if (mediaType === 'application' && versions?.length > 0) {
        const mimeType = m.mimetype || ''
        if (mimeType.includes('heic') || mimeType.includes('heif')) {
            const hasProcessedVersion = versions.some((v: any) => v.mimetype === 'image/jpeg' || v.mimetype === 'image/png')
            if (hasProcessedVersion) {
                mediaType = 'image'
            }
        }
    }

    return {
        id: m.id,
        ownerId: m.ownerId,
        fileName: m.fileName,
        mediaType,
        contentLength: m.contentLength,
        url: m.url,
        mimeType: m.mimetype,
        width: (m.meta as any)?.width,
        height: (m.meta as any)?.height,
        duration: (m.meta as any)?.duration,
        orientation: (m.meta as any)?.orientation,
        isLocalMedia: false,
        state: 'remote',
        versions,
        uploadProgress: 0, // 0 - 1.0
        updatedDate: m.updatedDate
    }
})
